<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="start"><a id="pagexv"></a><a id="preface">Preface</a></h1><a id="preface">
<p class="noind" style="margin-top:30px;">A<span class="small">N ANCIENT TRADITION TELLS</span> us that the interval between the birth of the parents and the arrival of their first offspring averages thirty years. We call that a generation. Thirty years ago, early in 1971, this book was born. And so now it is beginning its second generation.</p>
<p class="ind">As the first generation ends, it is almost a cliché to say that enormous changes have occurred during the time that has passed. Yet vast changes certainly have affected the present-day descendants of the old tribal prophets whose stories are told in these pages.</p>
<p class="ind">During the past generation, some tribal reservations have prospered, others have not. There are now, and probably always will be, disagreements within tribes as to the direction their people should take. In spite of the many personal frustrations and difficulties young seekers of knowledge experience, it is no longer unusual to meet American-Indian lawyers, physicians, college professors, computer specialists, artists, writers, or members of almost any other profession or trade. Yet on some reservations there is still a shortage of proper places in which to live. And the county with the deepest poverty in the United States is still a tribal reservation.</p>
<p class="ind">Judging from letters I have received through the years, the readers who have given life to this book come from almost all the hundred or so ethnic groups that comprise this unique and awesome place called America. Small though the comparative number of American Indians is, almost all other Americans seem to have an earnest fascination for their history, their arts and literature, their attitude toward the natural world, and their philosophy of human existence.</p>
<p class="ind">And this wide interest exists beyond the borders of America into the lands of other people and other cultures. Name a small nation, one whose people have a history of past injustices and oppression, and this book will likely be in print there.</p>
<p class="ind" id="pagexvi">We rarely know the full power of words, in print or spoken. It is my hope that time has not dulled the words herein and that they will continue through the coming generation to be as true and direct as I originally meant them to be.</p>
<blockquote>
<p class="right"><span class="small">DEE BROWN</span></p>
<p class="right">in the year 2000</p>
</blockquote>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-start.vue?475bb5b9